module.exports = __webpack_public_path__ + "img/21.ac3b5068.png";